import { CommonModule } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-shared-indicator',
  standalone: true,
  imports: [RouterModule, TranslateModule, CommonModule],
  templateUrl: './shared-indicator.component.html',
  styleUrl: './shared-indicator.component.scss'
})
export class SharedIndicatorComponent {
  hoverIndicatorId = 0
  @Input() indicator: any;
  @Input() selectedStrategyId: any;
  @Input() isClickable: boolean = true;
  onMouseEnter(hoverIndicatorId: number) {
    this.hoverIndicatorId = hoverIndicatorId;
  }
  onMouseLeave() {
    this.hoverIndicatorId = 0;
  }

}
